import React from 'react';
import {
  makeStyles,
  mergeClasses,
  shorthands,
  Text,
  tokens,
} from '@fluentui/react-components';

const useBannerTitleStyles = makeStyles({
  root: {
    position: 'relative',
    ...shorthands.gridArea('title'),
    fontWeight: 'bold',
    paddingTop: tokens.spacingHorizontalXL,
    paddingRight: tokens.spacingHorizontalXL,
    paddingBottom: tokens.spacingVerticalXL,
    marginTop: 0,
    marginBottom: 0,
  },
});

export const BannerTitle: React.FC<{ children: React.ReactNode }> = React.memo(({ children }) => {
  const classes = useBannerTitleStyles();

  return (
    <Text as="h3" className={mergeClasses(classes.root, 'banner-title')}>
      {children}
    </Text>
  );
});
